import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col } from 'reactstrap';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import { userHasFeature } from '../../helpers/Features';

import EmptyStateVideo from './components/Video';
import UnlockButton from './components/UnlockButton';

const EmptyCustomFields = ({ link }) => {
  const intl = useIntl();

  return (
    <div className="empty-state-wrapper row align-items-center justify-content-center pt-4">
      <Col lg="5" xs="12">
        <h2>{intl.formatMessage({ defaultMessage: 'Your files, your fields' })}</h2>
        <div className="mt-4">
          {intl.formatMessage({
            defaultMessage: 'Create custom fields to store extra details about your files—from notes and credits to links and references. Organize metadata beyond tags and make your content more searchable and meaningful.',
          })}
        </div>
        {userHasFeature('custom-fields') ? (
          <Button color="primary" className="mt-4" tag={Link} to={link}>
            {intl.formatMessage({ defaultMessage: 'Add Custom Field' })}
          </Button>
        ) : (
          <UnlockButton feature="custom-fields" />
        )}
      </Col>
      <EmptyStateVideo video="custom-fields" />
    </div>
  );
};

EmptyCustomFields.propTypes = {
  link: PropTypes.string,
};

EmptyCustomFields.defaultProps = {
  link: null,
};

export default EmptyCustomFields;
